import { createAction, union } from '@ngrx/store';
import { Process } from '@zerops/models/process';
import {
  zefActionPayload,
  zefActionFailPayload,
  zefActionSuccessPayload
} from '@zerops/zef/core';

export const syncHttpRouting = createAction(
  '[@zerops/zerops/core/http-routing-base] sync',
  zefActionPayload<string, { global: boolean }>()
);

export const syncHttpRoutingFail = createAction(
  '[@zerops/zerops/core/http-routing-base] sync/fail',
  zefActionFailPayload
);

export const syncHttpRoutingSuccess = createAction(
  '[@zerops/zerops/core/http-routing-base] sync/success',
  zefActionSuccessPayload<Process>()
);

export const triggerDomainsDnsCheck = createAction(
  '[@zerops/zerops/core/http-routing-base] trigger-domains-dns-check',
  zefActionPayload<{ httpRoutingId: string; domainNames: string[] | null }>()
);

export const triggerDomainsDnsCheckFail = createAction(
  '[@zerops/zerops/core/http-routing-base] trigger-domains-dns-check/fail',
  zefActionFailPayload
);

export const triggerDomainsDnsCheckSuccess = createAction(
  '[@zerops/zerops/core/http-routing-base] trigger-domains-dns-check/success',
  zefActionSuccessPayload<{ success: boolean }>()
);

const all = union({
  syncHttpRouting,
  syncHttpRoutingFail,
  syncHttpRoutingSuccess,
  triggerDomainsDnsCheck,
  triggerDomainsDnsCheckFail,
  triggerDomainsDnsCheckSuccess
});

export type HttpRoutingBaseActionUnion = typeof all;
